// A reply that failed or was cut off (page closed / reloaded mid-stream)
// gets a clear notice with Retry instead of raw "Error: …" text or a
// spinner that never ends. Module scope.

// Plain-language versions of the errors people actually hit.
export function friendlyError(raw) {
  const t = String(raw || "").replace(/^Error:\s*/i, "").trim();
  if (!t) return "Something went wrong while answering.";
  if (/failed to fetch|networkerror|network error|load failed|err_internet|offline/i.test(t)) return "Couldn't reach the server. Check your connection and try again.";
  if (/timed? ?out|timeout|\b504\b|gateway time-?out/i.test(t)) return "The model took too long to respond. Try again, or pick a faster model.";
  if (/\b(429|rate.?limit|too many requests)\b/i.test(t)) return "Too many requests right now. Wait a moment and try again.";
  if (/\b(500|502|503)\b|bad gateway|service unavailable|upstream/i.test(t)) return "The model provider had a problem. Try again in a moment.";
  return t.length > 300 ? t.slice(0, 300) + "…" : t;
}

export default function ReplyNotice({ kind, text, onRetry, busy, S }) {
  const interrupted = kind === "interrupted";
  const color = interrupted ? (S.warning || "#d97706") : S.danger;
  return (
    <div role="status" className="cf-reply-notice" style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", marginTop: 6, borderRadius: 10, background: color + "12", border: `1px solid ${color}40`, maxWidth: 640 }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {interrupted
          ? <><circle cx="12" cy="12" r="10" /><line x1="10" y1="9" x2="10" y2="15" /><line x1="14" y1="9" x2="14" y2="15" /></>
          : <><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></>}
      </svg>
      <span style={{ flex: 1, fontSize: 13, color: S.text, lineHeight: 1.5 }}>
        {interrupted ? "This reply was interrupted before it finished." : friendlyError(text)}
      </span>
      {onRetry && (
        <button onClick={onRetry} disabled={busy}
          style={{ padding: "6px 12px", borderRadius: 8, border: `1px solid ${S.border2}`, background: S.surface || S.cardBg, color: S.text, fontSize: 12.5, fontWeight: 600, cursor: busy ? "default" : "pointer", fontFamily: "inherit", opacity: busy ? 0.5 : 1, flexShrink: 0 }}>
          Retry
        </button>
      )}
    </div>
  );
}
